<template>
    <el-dialog
        class="sub-window-dialog"
        :width="windowWidth > 600 ? '563px' : '100%'"
        :top="windowWidth > 600 ? '15vh' : '0'"
        :append-to-body="true"
        :visible="dialogVisible"
        @close="onClose"
    >
        <button class="btn popup__close" @click.prevent="onClose">
            <i class="el-icon-close"></i>
        </button>

        <template v-if="step === STEP_EXTEND">
            <div class="sub-window-container">
                <div class="sub-window-img">
                    <img
                        src="../../../img/subscriptions/sub-cancel.png"
                        alt="cancel"
                    />
                </div>
                <div class="sub-window-info">
                    <h3 class="sub-window-title">
                        {{ $lang("subscriptionWindow.step1.title") }}
                    </h3>
                    <p class="sub-window-text">
                        {{ $lang("subscriptionWindow.step1.text") }}
                    </p>
                    <div class="sub-buttons sub-window-buttons">
                        <button
                            class="sub-button sub-button--primary sub-window-button"
                            @click="step = extendSubscription()"
                        >
                            {{ $lang("subscriptionWindow.step1.stay") }}
                        </button>

                        <button
                            class="sub-button sub-button--tertiary sub-window-button"
                            @click="step = getStepForNonExtend()"
                        >
                            {{ $lang("subscriptionWindow.cancel") }}
                        </button>
                    </div>
                </div>
            </div>
        </template>

        <template v-if="step === STEP_CONFIRM">
            <div class="sub-window-container">
                <div class="sub-window-img">
                    <img
                        src="../../../img/subscriptions/sub-argument.png"
                        alt="sub-argument"
                    />
                </div>
                <div class="sub-window-info">
                    <h3 class="sub-window-title">
                        {{ $lang("subscriptionWindow.step11.title") }}
                    </h3>
                    <p class="sub-window-text">
                        {{ $lang("subscriptionWindow.step11.text") }}
                    </p>
                    <div class="sub-buttons sub-window-buttons">
                        <button
                            class="sub-button sub-button--primary sub-window-button"
                            @click="showTarrifs"
                        >
                            {{ $lang("subscriptionWindow.step11.tariffs") }}
                        </button>
                        <button
                            class="sub-button sub-button--tertiary sub-window-button"
                            @click="unsubscribe()"
                        >
                            {{ $lang("subscriptionWindow.cancel") }}
                        </button>
                    </div>
                </div>
            </div>
        </template>

        <template v-if="step === STEP_WARNING">
            <div class="sub-window-container">
                <div class="sub-window-img">
                    <img
                        src="../../../img/subscriptions/sub-warning.png"
                        alt="sub-warning"
                    />
                </div>
                <div class="sub-window-info">
                    <h3 class="sub-window-title">
                        {{ $lang("subscriptionWindow.step22.title") }}
                    </h3>
                    <p class="sub-window-text">
                        {{ $lang("subscriptionWindow.step22.text") }}
                    </p>
                    <div class="sub-buttons sub-window-buttons">
                        <button
                            class="sub-button sub-button--primary sub-window-button"
                            @click="onClose"
                        >
                            {{ $lang("subscriptionWindow.step22.stay") }}
                        </button>
                        <button
                            class="sub-button sub-button--tertiary sub-window-button"
                            @click="unsubscribe()"
                        >
                            {{ $lang("subscriptionWindow.cancel") }}
                        </button>
                    </div>
                </div>
            </div>
        </template>
    </el-dialog>
</template>

<script>
import { mapActions } from "vuex";
import ApiService from "../../api/api";

const STEP_EXTEND = 1;
const STEP_WARNING = 22;
const STEP_CONFIRM = 11;

export default {
    name: "SubscriptionWindow",
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        this.setInitialStep();
    },
    data() {
        return {
            windowWidth: window.innerWidth,
            step: 1,
            isProcessing: false,
            STEP_EXTEND,
            STEP_CONFIRM,
            STEP_WARNING
        };
    },
    methods: {
        ...mapActions("subscription", ["openUnsubscribeWindow"]),
        showTarrifs() {
            let route = this.$router.resolve({
                name: "prices",
                query: { isSubscriptionSelected: 1 }
            }).href;

            window.location.href = route;
        },
        setInitialStep() {
            let subscription = window.laravel.subscription;

            if (subscription === null) {
                this.step = STEP_EXTEND;

                return;
            }

            if (
                subscription.extended_at !== null ||
                subscription.subscription_type.is_promo === true
            ) {
                this.step = this.getStepForNonExtend();
            } else {
                this.step = STEP_EXTEND;
            }
        },
        extendSubscription() {
            if (this.isProcessing === true) {
                return;
            }

            this.isProcessing = true;

            ApiService.post("/subscription/extend").then(response => {
                const data = response.data;

                laravel.latestSubscription.extended_at = data.extended_at;
                laravel.latestSubscription.finished_at = data.finished_at;
                laravel.subscription.extended_at = data.extended_at;
                laravel.subscription.finished_at = data.finished_at;

                this.isProcessing = false;

                this.$emit("change", data, data);
                this.$emit("close");
            });
        },
        unsubscribe() {
            if (this.isProcessing === true) {
                return;
            }

            this.isProcessing = true;

            ApiService.post("/subscription/unsubscribe").then(response => {
                this.isProcessing = false;
                const data = response.data;

                const currentSubscription = data.subscription_type_id === 4 && data.price === 1 ? null : data;

                window.laravel.latestSubscription = data;
                window.laravel.subscription = currentSubscription;

                this.openUnsubscribeWindow();
                this.$emit("change", currentSubscription, data);
                this.$emit("close");
            });
        },
        getStepForNonExtend() {
            if (window.laravel.subscription.page_count === 0) {
                return (this.step = STEP_CONFIRM);
            }

            return (this.step = STEP_WARNING);
        },
        onClose() {
            this.setInitialStep();
            this.$emit("close");
        }
    }
};
</script>
